import React from 'react';
import { Building, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const RefundReceipt = ({
  request,
  refund,
  receiptNumber,
  organizationInvoiceData = { orgNameInvoice: "EGARHUB", footerInvoice: "" }
}) => {
  const { t } = useTranslation();
  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();

  const totalDeposits = request?.deposits?.reduce((sum, deposit) => deposit.paymentType === 'deposit' ? sum + deposit.amountPaid : sum, 0);

  return (
    <div className="bg-white p-8 max-w-md mx-auto font-mono text-sm">
      {/* Header */}
      <div className="text-center mb-6 border-b-2 border-dashed border-gray-300 pb-4">
        <div className="flex justify-center mb-2">
          <Building size={32} className="text-gray-600" />
        </div>
        <h1 className="text-lg font-bold text-gray-900">
          {organizationInvoiceData?.orgNameInvoice || organizationInvoiceData?.orgName}
        </h1>
        <p className="text-xs text-gray-500 mt-1">
          {t('refundReceipt')}
        </p>
      </div>

      {/* Receipt Info */}
      <div className="mb-4 space-y-1">
        <div className="flex justify-between">
          <span className="text-gray-600">{t('receiptNumber')}</span>
          <span className="font-semibold">{refund?.paymentId || "receiptNumber"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('date')}</span>
          <span>{currentDate}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('time')}</span>
          <span>{currentTime}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('requestNumber')}</span>
          <span>{request.reqCode}</span>
        </div>
        {/* <div className="flex justify-between">
          <span className="text-gray-600">{t('refundStatus')}</span>
          <span className={`font-semibold ${refund.status === 'confirmed' ? 'text-green-600' : 'text-orange-600'}`}>
            {t(refund.status)}
          </span>
        </div> */}
      </div>

      <div className="border-t border-dashed border-gray-300 pt-3 mb-4"></div>

      {/* Guest Info */}
      <div className="mb-4 space-y-1">
        <h3 className="font-semibold text-gray-800 mb-2">
          {t('guestInformation')}
        </h3>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('name')}</span>
          <span className="font-medium">{request.clientName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('phone')}</span>
          <span dir='ltr'>{request.phone}</span>
        </div>
        {/* <div className="flex justify-between">
          <span className="text-gray-600">{t('email')}</span>
          <span className="text-xs">{request.email}</span>
        </div> */}
      </div>

      <div className="border-t border-dashed border-gray-300 pt-3 mb-4"></div>

      {/* Booking Info */}
      <div className="mb-4 space-y-1">
        <h3 className="font-semibold text-gray-800 mb-2">
          {t('bookingDetails')}
        </h3>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('unit')}</span>
          <span>{request.unitName} - {request.unitCode}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('checkIn')}</span>
          <span>{new Date(request.checkIn).toLocaleDateString()}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('checkOut')}</span>
          <span>{new Date(request.checkOut).toLocaleDateString()}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('totalAmount')}</span>
          <span className="font-semibold">{request.totalAmount.toLocaleString()} {t("EGP")}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('totalDeposits')}</span>
          <span className="font-semibold">{totalDeposits.toLocaleString()} {t("EGP")}</span>
        </div>
      </div>

      <div className="border-t border-dashed border-gray-300 pt-3 mb-4"></div>

      {/* Refund Info */}
      <div className="mb-6 space-y-1">
        <h3 className="font-semibold text-gray-800 mb-2">
          {t('refundDetails')}
        </h3>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('refundAmount')}</span>
          <span className="font-bold text-lg text-red-600">{refund.amountPaid.toLocaleString()} {t("EGP")}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">{t('paymentMethod')}</span>
          <span className="">{t(refund.paymentMethod)}</span>
        </div>
        {refund.createdAt && <div className="flex justify-between">
          <span className="text-gray-600">{t('refundDate')}</span>
          <span>{new Date(refund.createdAt).toLocaleDateString()}</span>
        </div>}
        {refund.notes && (
          <div className="mt-2">
            <span className="text-gray-600">{t('refundReason')}</span>
            <p className="text-xs mt-1 text-gray-700">{refund.notes}</p>
          </div>
        )}
      </div>

      <div className="border-t-2 border-dashed border-gray-300 pt-4 mb-6"></div>

      {/* Refund Summary */}
      {/* <div className="mb-6 bg-red-50 p-3 rounded">
        <h4 className="font-semibold text-red-800 mb-2">
          {t('refundSummary')}
        </h4>
        <div className="space-y-1 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">{t('amountPaid')}</span>
            <span>{totalDeposits.toLocaleString()} {t("EGP")}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">{t('amountDue')}</span>
            <span>{request.totalAmount.toLocaleString()} {t("EGP")}</span>
          </div>
          <div className="flex justify-between border-t border-red-200 pt-1">
            <span className="font-semibold text-red-700">{t('refundAmount')}</span>
            <span className="font-bold text-red-700">{refund.amountPaid.toLocaleString()} {t("EGP")}</span>
          </div>
        </div>
      </div> */}

      {/* Important Notice */}
      <div className="mb-6 bg-yellow-50 border border-yellow-200 p-3 rounded">
        <div className="flex items-start space-x-2">
          <AlertTriangle size={16} className="text-yellow-600 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs text-yellow-800 font-semibold mb-1">
              {t('importantNotice')}
            </p>
            <p className="text-xs text-yellow-700">
              {t('refundAcknowledgment')}
            </p>
          </div>
        </div>
      </div>

      {/* Signatures */}
      <div className="space-y-6 mb-6">
        <div>
          <p className="text-xs text-gray-600 mb-3">
            {t('guestSignature')}
          </p>
          <div className="border-b-2 border-gray-400 h-10 mb-2"></div>
          <div className="flex justify-between text-xs text-gray-500">
            <span>{t('signature')}</span>
            <span>{t('date')}</span>
          </div>
          <p className="text-xs text-gray-500 mt-2">
            {t('refundReceiptAcknowledgment')}
          </p>
        </div>

        <div>
          <p className="text-xs text-gray-600 mb-3">
            {t('staffSignature')}
          </p>
          <div className="border-b-2 border-gray-400 h-10 mb-2"></div>
          <div className="flex justify-between text-xs text-gray-500">
            <span>{t('signatureAndStamp')}</span>
            <span>{t('date')}</span>
          </div>
          <p className="text-xs text-gray-500 mt-2">
            {t('frontOfficeStaff')}
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center text-xs text-gray-500 border-t border-dashed border-gray-300 pt-3">
        <p>{t('thankYou')}</p>
        <p className="mt-1" >
          {t('forInquiriesEmail')}
          <span dir='ltr'> {organizationInvoiceData?.orgPhone}  </span>
        </p>
        <p className="mt-2 text-xs">
          {t('keepReceipt')}
        </p>
        <p className="mt-2 text-xs">
          {organizationInvoiceData?.footerInvoice}
        </p>
      </div>
    </div>
  );
};